import Bowser from "bowser";
// import Stripe from 'stripe';
// import * as csLogHelper from "./helpers/CsLogHelper";
// import {LogMessageTypeEnum} from "./helpers/CsLogHelper";

// import DotNetObject = DotNet.DotNetObject;

export class BrowserWindowInfo {
  public width: number | undefined | null;

  public height: number | undefined | null;

  public devicePixelRatio: number | undefined | null;
}

export class CsJsHelper {
  // private readonly _ClassName: string = "CsJsHelper";
  // private _Stripe: Stripe | null = null;
  
  public getParsedUserAgent(): Bowser.Parser.ParsedResult {
    const parsedResult = Bowser.parse(window.navigator.userAgent);
    console.log(parsedResult);
    return parsedResult;
  };

  private static getDevicePixelRatio(): number {
    let mediaQuery;
    let is_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (window.devicePixelRatio !== undefined && !is_firefox) {
      return window.devicePixelRatio;
    } else if (window.matchMedia) {
      mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
          (min--moz-device-pixel-ratio: 1.5),\
          (-o-min-device-pixel-ratio: 3/2),\
          (min-resolution: 1.5dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 1.5;
      }
      mediaQuery = "(-webkit-min-device-pixel-ratio: 2),\
          (min--moz-device-pixel-ratio: 2),\
          (-o-min-device-pixel-ratio: 2/1),\
          (min-resolution: 2dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 2;
      }
      mediaQuery = "(-webkit-min-device-pixel-ratio: 0.75),\
          (min--moz-device-pixel-ratio: 0.75),\
          (-o-min-device-pixel-ratio: 3/4),\
          (min-resolution: 0.75dppx)";
      if (window.matchMedia(mediaQuery).matches) {
        return 0.7;
      }
    } else {
      return 1;
    }
    
    return 0;
  }

  public getBrowserWindowInfo(): BrowserWindowInfo {
    const windowWidth: number = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;

    const windowHeight: number = window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;

    const browserWindowInfo = new BrowserWindowInfo();
    browserWindowInfo.width = windowWidth;
    browserWindowInfo.height = windowHeight;
    browserWindowInfo.devicePixelRatio = CsJsHelper.getDevicePixelRatio();

    return browserWindowInfo;
  }

  // private getStripe = (
  //   stripePublicKey: string): Stripe => {
  //   if (!this._Stripe) {
  //     this._Stripe = new Stripe(stripePublicKey, {
  //       // ...
  //     });
  //   }
  //   return this._Stripe;
  // };
  //
  // public async redirectToStripeCheckoutAsync(
  //   sessionId: string,
  //   stripePublicKey: string,
  //   isDebugging: boolean
  // ): Promise<Boolean> {
  //   const thisInstance = this;
  //   const methodName = 'initAsync()';
  //
  //   await csLogHelper.logAsync(
  //     LogMessageTypeEnum.Warning,
  //     isDebugging,
  //     thisInstance._ClassName,
  //     methodName,
  //     "ENTERED",
  //     null
  //   );
  //
  //   return new Promise(async function (resolve, reject) {
  //     try {
  //       await csLogHelper.logAsync(
  //         LogMessageTypeEnum.Warning,
  //         isDebugging,
  //         thisInstance._ClassName,
  //         methodName,
  //         'ENTERED : Promise',
  //         null
  //       );
  //       const stripe = new Stripe(stripePublicKey, {
  //         // ...
  //       });
  //       stripe.checkout({
  //         sessionId: sessionId
  //       }).then(async function (result: any) {
  //         if (result.error) {
  //           await csLogHelper.logAsync(
  //             LogMessageTypeEnum.Error,
  //             isDebugging,
  //             thisInstance._ClassName,
  //             methodName,
  //             'Error Running - ' + methodName,
  //             result.error
  //           );
  //          
  //           return reject(result.error);
  //         }
  //         else
  //         {
  //           return resolve(true);    
  //         }
  //       });
  //      
  //     } catch (err) {
  //       await csLogHelper.logAsync(
  //         LogMessageTypeEnum.Error,
  //         isDebugging,
  //         thisInstance._ClassName,
  //         methodName,
  //         'Error Running - ' + methodName,
  //         err
  //       );
  //
  //       return reject(err)
  //     }//catch
  //   });//promise
  // }

  // public registerBrowserWindowResizeListener(dotNetObject: DotNetObject) {
  //   window.onresize = function () {
  //     let browserHeight = window.innerHeight;
  //     let browserWidth = window.innerWidth;
  //     dotNetObject.invokeMethodAsync('BrowserWindowResizedAsync', browserWidth, browserHeight).then(() => {
  //       // success, do nothing
  //     }).catch(error => {
  //       console.log("Error during browser resize: " + error);
  //     });
  //   };
  // }
}

// declare module globalThis {
//   let __CsJsHelper: CsJsHelper;
// }
//
// // TODO: is this needed with the below listener event???
// globalThis.__CsJsHelper = new CsJsHelper();
// window.__CsJsHelper = globalThis.__CsJsHelper;
